export default `
query QueryShiftsByServiceProviderIdStartTimeIndex(
  $serviceProviderId: ID!, 
  $to: Float, 
  $from: Float, 
  $after: String, 
  $includeDeleted: Boolean
) {
  queryShiftsByServiceProviderIdStartTimeIndex(
    serviceProviderId: $serviceProviderId, 
    to: $to, 
    from: $from, 
    after: $after, 
    includeDeleted: $includeDeleted
  ) {
    items {
      createdAt
      updatedAt
      publishedAt
      acknowledgedAt
      updatedBy
      shiftId
      status
      createdBy
      userId
      isDeleted
      propertyId
      note
      startTime
      endTime
      serviceProviderId
      requests
      divisionId
      requiredLevels
      timezone
      postOrders {
        description
        time {
          start
          end
        }
        propertyId
        dar {
          isRequired
          darId
        }
        completed {
          timestamp
          coordinates {
            lat
            lng
          }
        }
      }
    }
    nextToken
  }
}
`;